import StatusChip from "../../common/components/StatusChip";

interface ServiceConnectionStatusChipProps {
	status: string;
	size?: "small" | "medium";
}

const statusColors: Record<string, "success" | "warning" | "error" | "default"> = {
	Connected: "success",
	Disconnected: "error",
	Pending: "warning",
};

export default function ServiceConnectionStatusChip({ status, size = "small" }: ServiceConnectionStatusChipProps) {
	return <StatusChip status={status} colorMap={statusColors} defaultColor="default" size={size} />;
}
